import { Breadcrumb, Breadcrumbs, Link } from "react-aria-components";

import { CaretRightIcon } from "#icons";

export interface BreadcrumbTab {
  label: string;
  target?: string;
}

interface BreadcrumbListProps {
  pathname: string;
  breadcrumbs: BreadcrumbTab[];
}

export function BreadcrumbNavList({ breadcrumbs }: BreadcrumbListProps) {
  const length = breadcrumbs.length;
  return (
    <Breadcrumbs aria-label="breadcrumb" className="flex items-center gap-sm">
      {breadcrumbs.map((breadcrumb, index) => (
        <Breadcrumb
          className="flex items-center gap-md"
          key={breadcrumb.target ?? breadcrumb.label}
        >
          {breadcrumb.target ? (
            <Link
              className="text text-label-medium text-interactive-tertiary-button-enabled-foreground data-[current]:font-bold data-[current]:text-text-primary"
              href={breadcrumb.target}
            >
              {breadcrumb.label}
            </Link>
          ) : (
            <span className="text-label-medium text-text-secondary">{breadcrumb.label}</span>
          )}
          {index !== length - 1 ? <CaretRightIcon className="text-foreground-primary" /> : null}
        </Breadcrumb>
      ))}
    </Breadcrumbs>
  );
}
